<template>
  <AppLayout>
    <div class="container mt-4">
      <h3>Lista kontaktów firmowych</h3>

      <div class="form-check mb-3">
        <div class="checkbox-success custom-control custom-checkbox d-inline-block mt-3">
          <input id="toggleAll" type="checkbox" class="custom-control-input" :checked="allSelected" @change="toggleAll">
          <label for="toggleAll" class="custom-control-label h6">Zaznacz wszystkich</label>
        </div>
		      <div class="d-flex flex-wrap gap-2 mt-3">
        <button class="btn btn-primary" :disabled="selected.length === 0" @click="downloadVcf">
          Pobierz zbiorczy vCard (na telefon)
        </button>
        <button class="btn btn-outline-primary" :disabled="selected.length === 0" @click="downloadVcfO">
          Pobierz paczkę plików vCard
        </button>
        <button class="btn btn-outline-primary" :disabled="selected.length === 0" @click="downloadCsv">
          Pobierz plik CSV
        </button>
      </div>
      </div>
      <div class="d-flex flex-wrap gap-2 mt-3">
        <div class="table-responsive">
          <table ref="vcfTable" class="table table-hover w-100" style="table-layout: fixed;">
            <thead>
            <tr>
              <th></th>
              <th>Imię</th>
              <th>Nazwisko</th>
              <th>Email</th>
              <th>Telefon</th>
            </tr>
            </thead>
            <tbody></tbody>
          </table>
        </div>
      </div>

    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import $ from "jquery";
import "datatables.net-bs5";

export default {
  name: "VCFExport",
  components: {AppLayout},
  props: {
    users: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selected: [],
      dataTable: null,
    };
  },
  computed: {
    allSelected() {
      return this.selected.length === this.users.length && this.users.length > 0;
    },
  },
  methods: {
    toggleAll() {
      if (this.allSelected) {
        this.selected = [];
      } else {
        this.selected = this.users.map(u => u.id);
      }
      this.updateCheckboxes();
    },

    updateCheckboxes() {
      const self = this;
      $(this.$refs.vcfTable)
          .find("tbody input[type=checkbox]")
          .each(function () {
            const id = parseInt($(this).val());
            $(this).prop("checked", self.selected.includes(id));
          });
    },

    onCheckboxChange(event) {
      const id = parseInt(event.target.value);
      if (event.target.checked) {
        if (!this.selected.includes(id)) this.selected.push(id);
      } else {
        this.selected = this.selected.filter(sid => sid !== id);
      }
    },
    async downloadCsv() {
      try {
        const response = await axios.post(
            "/generate-csv",
            {user_ids: this.selected},
            {responseType: "blob"}
        );

        const url = window.URL.createObjectURL(new Blob([response.data], {type: "text/csv"}));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "askla-contacts.csv");
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error("Błąd podczas pobierania pliku CSV:", error);
      }
    },
    async downloadVcf() {
      try {
        const response = await axios.post(
            "/generate-vcf",
            {user_ids: this.selected},
            {responseType: "blob"}
        );

        const url = window.URL.createObjectURL(new Blob([response.data], {type: "text/vcard"}));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "askla-contacts.vcf");
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error("Błąd podczas pobierania pliku VCF:", error);
      }
    },
    async downloadVcfO() {
      try {
        const response = await axios.post(
            "/generate-vcf-outlook",
            {user_ids: this.selected},
            {responseType: "blob"}
        );

        const url = window.URL.createObjectURL(new Blob([response.data], {type: "application/zip"}));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "askla-contacts.zip");
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error("Błąd podczas pobierania pliku ZIP:", error);
      }
    },

    rowCallback(row, data) {
      const self = this;

      // Dodaj checkbox z eventem
      const $checkbox = $('<input type="checkbox" class="checkbox-success custom-control custom-checkbox">')
          .val(data.id)
          .prop("checked", self.selected.includes(data.id))
          .on("change", (e) => self.onCheckboxChange(e));

      // Wstaw checkbox do pierwszej kolumny
      $("td:eq(0)", row).html($checkbox);
    },
  },

  mounted() {
    const self = this;

    this.dataTable = $(this.$refs.vcfTable).DataTable({
      data: this.users,
      columns: [
        {data: null, orderable: false, searchable: false, width: "5%"},
        {data: "first_name", width: "20%"},
        {data: "last_name", width: "20%"},
        {data: "email", width: "20%"},
        {data: "phone", width: "20%"},
      ],
      order: [[1, "asc"]],
      paging: false,
      searching: true,
      info: true,
      rowCallback: this.rowCallback,
    });
  },

  beforeUnmount() {
    if (this.dataTable) {
      this.dataTable.destroy();
      this.dataTable = null;
    }
  },
};
</script>
